import { z } from "zod";

export const UserRoleSchema = z.enum(["clientUser", "clientAdmin", "systemAdmin"]);
export type TUserRole = z.infer<typeof UserRoleSchema>;

export const UserStatusSchema = z.enum(["active", "inactive", "pending"]);
export type TUserStatus = z.infer<typeof UserStatusSchema>;

export const UserSchema = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  role: UserRoleSchema,
  createdAt: z.coerce.date(),
  status: UserStatusSchema,
  projects: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      createdAt: z.coerce.date()
    })
  )
});

export type TUser = z.infer<typeof UserSchema>;

export const GetUsersSchema = z.array(UserSchema);

export type TGetUsersResponse = z.infer<typeof GetUsersSchema>;

export const ProjectOverallStatus = z.enum(["start", "mid", "end"]).nullable();
export type TProjectOverallStatus = z.infer<typeof ProjectOverallStatus>;

export const ProjectMarketFeedback = z.enum(["positive", "negative", "neutral", "unknown"]).nullable();
export type TProjectMarketFeedback = z.infer<typeof ProjectMarketFeedback>;

export const AdminProjectResponseSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  organizationId: z.coerce.number(),
  createdById: z.coerce.number(),
  projectTemplateId: z.coerce.number(),
  temporaryStageId: z.coerce.number().nullable(),
  shortDescription: z.string().nullable(),
  startYear: z.number().nullable(),
  logoUrl: z.string().nullable(),
  location: z.string().nullable(),
  overallStatus: ProjectOverallStatus,
  riskLevel: ProjectOverallStatus,
  marketFeedback: ProjectMarketFeedback,
  createdAt: z.date(),
  updatedAt: z.date()
});

export type TAdminProject = z.infer<typeof AdminProjectResponseSchema>;

export const AdminListProjectsResponseSchema = z.array(AdminProjectResponseSchema);

export type TAdminListProjectsResponse = z.infer<typeof AdminListProjectsResponseSchema>;
